import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { storyblokInit, apiPlugin } from '@storyblok/react';

import Page from './components/Page';
import Teaser from './components/Teaser';
import Grid from './components/Grid';
import Feature from './components/Feature';
import WunderElement from './components/WunderElement';

storyblokInit({
    accessToken: 'Ju5bayQR7SHNk6PG7KqFmwtt',
    use: [apiPlugin],
    components: {
        page: Page,
        teaser: Teaser,
        grid: Grid,
        feature: Feature,
        WunderElement: WunderElement,
    },
});

ReactDOM.render(<App />, document.getElementById('root'));
